import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { HttpService } from '../../shared/services/http.service';

@Component({
  selector: 'app-wp-button',
  templateUrl: './wp-button.component.html',
  styleUrl: './wp-button.component.css',
})
export class WpButtonComponent {
  @Input() wpList: any = {};
  @Input() brandLists: any = [];
  @Input() businessThemeLists: any = [];
  @Input() teamMembersLists: any = [];
  @Input() loading: boolean = false;
  @Input() userData: any;
  wpFormModal: boolean = false;
  isDiscuss: boolean = false;
  httpService = inject(HttpService);
  @Output() createFormWP: EventEmitter<any> = new EventEmitter<any>();

  createWP() {
    this.wpFormModal = true;
  }

  closeModel(event:any){
    this.wpFormModal = event;
  }

  triggerDiscussion() {
    this.isDiscuss = true;
    // this.wpFormModal = false;
  }
}
